import Big from "big.js";

export function validateLineAmountsFunction(
  lineAmount?: number,
  quantity?: number,
  price?: number,
): "ok" | "error" {
  try {
    const preparedLineAmount = Big(lineAmount || 0);
    const preparedQuantity = Big(quantity || 0);
    const preparedPrice = Big(price || 0);
    const expectedTotal = preparedQuantity.times(preparedPrice);
    const leeway = Big("1.0");
    const leeway_negative = Big("-1.0");
    const difference = preparedLineAmount.sub(expectedTotal);

    return difference.lte(leeway) && difference.gte(leeway_negative)
      ? "ok"
      : "error";
  } catch (err: unknown) {
    return "error";
  }
}
